module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body reports-admin-panel"
  }, [_c('div', [_c('h3', {
    staticClass: "atd-box-title"
  }, [_vm._v("Site Name alias")]), _vm._v(" "), [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("Upload CSV")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("Add single entry")]), _vm._v(" "), (_vm.radio == '1') ? _c('div', {
    staticClass: "dis-flex"
  }, [_c('div', {
    staticClass: "p-r-10"
  }, [_vm._v("upload csv format:")]), _c('JsonCSV', {
    staticClass: "data--csv",
    attrs: {
      "data": _vm.jsonData,
      "name": "site-name-alias-format.csv"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.radio == '2') ? _c('div', {
    staticClass: "atd-add-remove-container"
  }, [_c('div', {
    staticClass: "atd-add-new-field"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addNewField
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tAdd +\n\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _vm._l((_vm.fields_alias), function(formField, index) {
    return _c('div', {
      staticClass: "dis-flex"
    }, [_c('el-button', {
      staticClass: "flex-order-3 atd-remove-new-field",
      attrs: {
        "icon": "el-icon-remove-outline"
      },
      on: {
        "click": function($event) {
          return _vm.removeField(index)
        }
      }
    }), _vm._v(" "), _c('el-input', {
      staticClass: "col-md-6 col-sm-6 col-xs-12 atd-input-alias",
      attrs: {
        "name": "fields_alias[][alias]",
        "placeholder": "alias",
        "clearable": ""
      },
      model: {
        value: (formField.alias),
        callback: function($$v) {
          _vm.$set(formField, "alias", $$v)
        },
        expression: "formField.alias"
      }
    }), _vm._v(" "), _c('el-select', {
      staticClass: "col-md-6 col-sm-6 col-xs-12 atd-input-site",
      attrs: {
        "name": "fields_alias[][site]",
        "filterable": "",
        "placeholder": "site"
      },
      model: {
        value: (formField.site),
        callback: function($$v) {
          _vm.$set(formField, "site", $$v)
        },
        expression: "formField.site"
      }
    }, _vm._l((_vm.publishersList), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1)], 1)
  }), _vm._v(" "), (_vm.fields_alias.length > 0) ? _c('el-button', {
    staticClass: "text-right",
    on: {
      "click": function($event) {
        return _vm.saveAliasData()
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 2) : _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "max-width": "900px",
      "margin": "0 auto"
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.uploading),
      expression: "uploading"
    }],
    ref: "upload",
    staticClass: "upload-demo m-t-20",
    attrs: {
      "drag": "",
      "limit": 1,
      "action": "reports/v1/upload/",
      "auto-upload": false,
      "http-request": _vm.upload,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "file-list": _vm.fileList
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("Drop file here or "), _c('em', [_vm._v("click to upload")])])]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("Submit")])], 1)], _vm._v(" "), [_c('el-table', {
    staticClass: "atd-dfp-report",
    attrs: {
      "data": _vm.siteAliasList,
      "height": "250"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "alias_site_name",
      "label": "Alias Site Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "site",
      "label": "Site"
    }
  })], 1)]], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border heading-cart"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Reports Settings")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46be5c59!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/reports/ReportsConfig.vue
// module id = 683
// module chunks = 2